import { API_CONFIG } from '@/config/envConfig';
import { apiClient } from '@/services/core/apiClient';

interface InboundFaxCountResponse {
  totalCount?: number;
}

export class FaxCountService {
  async getInboundFaxCount(token: string): Promise<number> {
    const response = await apiClient.get<InboundFaxCountResponse>(
      `${API_CONFIG.API_BASE_FAX_SERVICE}/api/faxes/inbound?pageIndex=0&itemCount=1`,
      token
    );

    if (!response.success) {
      throw new Error(response.error || 'Failed to fetch fax count');
    }

    return response.data?.totalCount ?? 0;
  }
}

export const faxCountService = new FaxCountService();